export default "__VITE_ASSET__a05599a9__"